import { render } from "./LockedStakingView.vue?vue&type=template&id=c9003ce0"
import script from "./LockedStakingView.vue?vue&type=script&lang=js"
export * from "./LockedStakingView.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__